var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4783 48.5827C14.2838 48.5694 4.40816 38.6783 4.417 26.4839C4.42583 14.2917 14.3147 4.4116 26.507 4.41602C38.7014 4.42043 48.5837 14.3049 48.5837 26.4994C48.577 38.7004 38.6793 48.5871 26.4783 48.5827ZM8.83366 26.8792C8.88386 31.548 10.7802 36.007 14.1082 39.2818C17.4362 42.5566 21.9253 44.3808 26.5943 44.3557C31.2632 44.3306 35.7324 42.4582 39.0251 39.1479C42.3177 35.8375 44.166 31.3583 44.166 26.6893C44.166 22.0202 42.3177 17.541 39.0251 14.2307C35.7324 10.9203 31.2632 9.04795 26.5943 9.02286C21.9253 8.99776 17.4362 10.8219 14.1082 14.0967C10.7802 17.3715 8.88386 21.8306 8.83366 26.4994V26.8792ZM28.7087 37.541H24.292V33.1244H28.7087V37.541ZM28.7087 28.7077H24.292V15.4577H28.7087V28.7077Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCycle);
export default __webpack_public_path__ + "static/media/error-cycle.3044cd0733e306e315be5cab711497ea.svg";
export { ForwardRef as ReactComponent };